<template>
  <div>
    <div class="modal-title">{{ $t('tour_setting_arrival_label') }}</div>
    <search-station :callback="callback" />
  </div>
</template>

<script>
import SearchStation from './SearchStation'

export default {
  components: {
    SearchStation
  },
  props: {
    callback: {
      type: Function,
      default: function () {
        return {}
      }
    }
  }
}
</script>
